import { createRequestType } from '../../helpers/requestType';
import { Event, Graph } from './types';

export const getMonitoringGraphActionType = createRequestType('GET_MONITORING_GRAPH');
interface getMonitoringGraphRequestAction {
  type: typeof getMonitoringGraphActionType.request;
  payload: any;
}

interface getMonitoringGraphSuccessAction {
  type: typeof getMonitoringGraphActionType.success;
  payload: Graph;
}

interface getMonitoringGraphFailureAction {
  type: typeof getMonitoringGraphActionType.failure;
  payload: any;
}

export const getMonitoringPathActionType = createRequestType('GET_MONITORING_PATH');
interface getMonitoringPathRequestAction {
  type: typeof getMonitoringPathActionType.request;
  payload: any;
}

interface getMonitoringPathSuccessAction {
  type: typeof getMonitoringPathActionType.success;
  payload: Graph;
}

interface getMonitoringPathFailureAction {
  type: typeof getMonitoringPathActionType.failure;
  payload: any;
}

export const updateMonitoringGraphActionType = createRequestType('UPDATE_MONITORING_GRAPH');

interface updateMonitoringGraphRequestAction {
  type: typeof updateMonitoringGraphActionType.request;
  payload: Graph
}

export const updateMonitoringPathActionType = createRequestType('UPDATE_MONITORING_PATH');

interface updateMonitoringPathRequestAction {
  type: typeof updateMonitoringPathActionType.request;
  payload: Graph
}

export const getEventsActionType = createRequestType('GET_EVENTS');
interface getEventsRequestAction {
  type: typeof getEventsActionType.request;
  payload: any;
}

interface getEventsSuccessAction {
  type: typeof getEventsActionType.success;
  payload: Event[];
}

interface getEventsFailureAction {
  type: typeof getEventsActionType.failure;
  payload: any;
}

export type MonitoringGraphActionTypes = getMonitoringGraphRequestAction | getMonitoringGraphSuccessAction| getMonitoringGraphFailureAction 
|  getMonitoringPathRequestAction | getMonitoringPathSuccessAction | getMonitoringPathFailureAction | updateMonitoringGraphRequestAction 
| updateMonitoringPathRequestAction | getEventsRequestAction | getEventsSuccessAction | getEventsFailureAction